import React from 'react'
import FeaturesAndAttributes from './FeaturesAndAttributes'
import ManageSizeValues from './ManageSizeValues'
import PackagingDetails from './PackagingDetails'
import PriceVariant from './PriceVariant'
import PricingCalculation from './PricingCalculation'
import PricingDetails from './PricingDetails'

const NotWarehousePrice = ({
  allState,
  values,
  setFieldValue,
  calculation,
  setCalculation,
  resetForm,
  errors,
  touched
}) => {
  return (
    <>
      {(allState?.color?.length > 0 || allState?.sizeType?.length > 0) && (
        <div className='card'>
          <div className='card-body'>
            <div>
              <h5 className='mb-3 head_h3'>Attributes</h5>
              {!values?.isExistingProduct && (
                <div className='row'>
                  <FeaturesAndAttributes
                    values={values}
                    setFieldValue={setFieldValue}
                    allState={allState}
                    resetForm={resetForm}
                  />

                  {values?.productPrices?.length > 0 &&
                    !values?.isSizeWisePriceVariant &&
                    allState?.sizeType?.length > 0 && (
                      <ManageSizeValues
                        values={values}
                        setFieldValue={setFieldValue}
                        errors={errors.productPrices}
                        resetForm={resetForm}
                        allState={allState}
                      />
                    )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <div className='row'>
        <div className='col-md-6'>
          <div className='card'>
            <div className='card-body'>
              <div className='row mb-3'>
                {values?.isSizeWisePriceVariant && (
                  <PackagingDetails
                    values={values}
                    setFieldValue={setFieldValue}
                    allState={allState}
                    calculation={calculation}
                    setCalculation={setCalculation}
                  />
                )}

                <PricingDetails
                  values={values}
                  allState={allState}
                  setFieldValue={setFieldValue}
                  setCalculation={setCalculation}
                  calculation={calculation}
                  resetForm={resetForm}
                  errors={errors.productPrices}
                  touched={touched}
                />

                {!values?.isSizeWisePriceVariant && (
                  <PackagingDetails
                    values={values}
                    setFieldValue={setFieldValue}
                    allState={allState}
                    calculation={calculation}
                    setCalculation={setCalculation}
                  />
                )}
              </div>
              <PriceVariant
                values={values}
                setFieldValue={setFieldValue}
                setCalculation={setCalculation}
                calculation={calculation}
                allState={allState}
                resetForm={resetForm}
                productPricesErrors={errors.productPrices}
              />
            </div>
          </div>
        </div>
        {calculation?.displayCalculation && (
          <PricingCalculation
            calculation={calculation}
            setCalculation={setCalculation}
          />
        )}
      </div>
    </>
  )
}

export default NotWarehousePrice
